import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { WarehouseStorageRate } from '../../models/warehouse-storage-rate.model';
import { WarehouseStorageRateService } from '../../services/warehouse-storage-rate.service';
import { WarehouseStorageRateValidatorService } from '../../validators/warehouse-storage-rate-validator.service';

@Component({
    selector: 'app-storage-rates-edit',
    templateUrl: './storage-rates-edit.component.html',
    styleUrls: ['./storage-rates-edit.component.scss'],
    standalone: false
})
export class StorageRatesEditComponent implements OnInit {

  rate: WarehouseStorageRate = new WarehouseStorageRate();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private storageRateValidator: WarehouseStorageRateValidatorService,
    private storageRateService: WarehouseStorageRateService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadStorageRate(+params['id']);
    })
  }

  loadStorageRate(id: number): void {
    this.storageRateService.getStorageRateById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((rate: WarehouseStorageRate) => {
      this.rate = rate;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.isSuccess = false;

    if (this.storageRateValidator.isValid(this.rate)) {
      this.storageRateService.updateStorageRate(this.rate)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }
}
